module.exports = __webpack_public_path__ + "static/media/users.90b83145.svg";